import 'antd/es/tabs/style/css';
import 'antd/es/carousel/style/css';
import 'antd/es/progress/style/css';
import './index.less';
import '../../theme/global.less';
import '../../theme/default.less';
import '../../theme/dark.less';
import '../../vtx-base-modal/style/index.less';
import '../../vm-filter/style/index.less';
import '../../vm-info-collection/style/index.less';
import '../../vm-chart/style/index.less';
import '../../vm-stat-collection/style/index.less';
import '../../vm-table/style/index.less';
import '../../vm-sub-tabs/style/index.less';
import '../../vm-car-history/style/index.less';
